/* Marcel Afters, CONVERSION (5 Oct 2026): card interaction layer (snippets/ma-alo-card.liquid).
   1. Colour dots: hover (mouse) previews that colour's own photo, tap/click chooses it (card links go to that colour).
   2. Quick add: bag button opens an inline size picker for the chosen colour; a size tap adds that exact variant through
      /cart/add.js + the theme's CartLinesUpdateEvent (same path as assets/ma-alo-pdp.js), so the bag drawer opens.
   Delegated, so Load more / rails work without re-binding. No dependencies; without JS the card is a plain link. */
(function () {
  if (window.__mxQa) return; window.__mxQa = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};
  function card(el) { return el.closest('[data-mx-card]'); }
  function dl(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }

  /* ---------- colour dots ---------- */
  /* GOLDEN RULE (style standard): the card always shows a MODEL first. A colour dot whose own photo is on-model (data-model)
     replaces the lead image with that colour's model; a dot whose own photo is a flat swaps the SECOND image (the hover flat)
     and reveals it. A colour with no photo of its own changes nothing (it still sets the colour for links and quick add). */
  function alt(c) { return c.querySelector('.mx-card__i2'); }
  function prim(c) { return c.querySelector('.mx-card__i1'); }
  function track(c) { return c.querySelector('[data-mx-track2]'); }
  function keep(img) { if (!('mxO' in img.dataset)) { img.dataset.mxO = img.getAttribute('src') || ''; img.dataset.mxOs = img.getAttribute('srcset') || ''; } }
  function reset(c) {
    [prim(c), alt(c)].forEach(function (img) {
      if (img && ('mxO' in img.dataset)) { img.srcset = img.dataset.mxOs; img.src = img.dataset.mxO; }
    });
    c.classList.remove('is-peek');
  }
  function apply(c, dot) {
    reset(c);
    if (!dot || !dot.dataset.img) return false;
    var img = dot.dataset.model ? prim(c) : alt(c); if (!img) return false;
    keep(img); img.removeAttribute('loading'); img.srcset = dot.dataset.srcset || ''; img.src = dot.dataset.img;
    if (!dot.dataset.model) c.classList.add('is-peek');
    return true;
  }
  function show(dot) { apply(card(dot), dot); }
  function restore(c) { apply(c, c.querySelector('.mx-sw__d[aria-pressed="true"]')); }
  function link(c, variant) {
    var a = c.querySelector('.mx-card__a'); if (!a) return;
    if (!a.dataset.mxHref) a.dataset.mxHref = a.getAttribute('href');
    var base = a.dataset.mxHref.split('?')[0];
    a.setAttribute('href', variant ? base + '?variant=' + variant : a.dataset.mxHref);
  }
  function chooseDot(dot) {
    var c = card(dot), was = dot.getAttribute('aria-pressed') === 'true';
    [].forEach.call(c.querySelectorAll('.mx-sw__d'), function (d) { d.setAttribute('aria-pressed', 'false'); });
    var t = track(c);
    if (!was) {
      dot.setAttribute('aria-pressed', 'true'); var ok = apply(c, dot); link(c, dot.dataset.variant);
      if (t && ok && !dot.dataset.model && document.documentElement.classList.contains('mx-touch')) t.scrollTo({ left: t.clientWidth, behavior: 'smooth' });
      else if (t && t.scrollLeft) t.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      restore(c); link(c, null);
      if (t && t.scrollLeft) t.scrollTo({ left: 0, behavior: 'smooth' });
    }
    // S3: colour tap opens its sizes; the second tap adds the shopper's exact variant.
    // Never infer a colour from the hero photograph or silently select a default.
    var q = c.querySelector('[data-mx-qa]');
    if (q) {
      var dd = data(q), pd = c.querySelector('.mx-sw__d[aria-pressed="true"]');
      q.__col = pd && dd ? dd.c[+pd.dataset.ci] : null;
      if (pd && dd) open(q); else if (q.classList.contains('is-open')) close(q, false);
    }
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var d = e.target.closest('.mx-sw__d'); if (d) show(d);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var g = e.target.closest('.mx-sw'); if (!g || (e.relatedTarget && g.contains(e.relatedTarget))) return;
    var c = card(g); if (c) restore(c);
  });

  /* ---------- quick add ---------- */
  function data(q) {
    if (q.__d) return q.__d;
    try { q.__d = JSON.parse(q.querySelector('[data-mx-qa-data]').textContent); } catch (e) { q.__d = null; }
    return q.__d;
  }
  function colour(q) {
    var d = data(q), c = card(q), on = c.querySelector('.mx-sw__d[aria-pressed="true"]');
    if (on) return d.c[+on.dataset.ci];
    if (q.__col != null) return q.__col;
    return d.c.length === 1 ? d.c[0] : null;   /* several colours and none chosen: never guess, ask */
  }
  function paint(q) {
    var d = data(q); if (!d) return;
    var col = colour(q), box = q.querySelector('[data-mx-qa-sizes]'), h = q.querySelector('[data-mx-qa-h]');
    var cbox = q.querySelector('[data-mx-qa-colours]');
    var cOnly = d.s.length === 1 && d.s[0] === '';   /* colour-only product: the colour tap adds it */
    h.textContent = cOnly ? 'Choose a colour' : (d.c.length === 1 ? 'Add size' : (col ? 'Colour \u00b7 ' + col : 'Choose a colour'));
    if (cbox) {
      cbox.textContent = '';
      d.c.forEach(function (name, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mx-qa__k' + (name === col ? ' is-on' : '');
        b.style.setProperty('--sw', d.h[i] || '#d2d9e7'); b.dataset.col = name; b.setAttribute('aria-label', name); b.setAttribute('aria-pressed', name === col ? 'true' : 'false');
        cbox.appendChild(b);
      });
    }
    box.textContent = '';
    if (cOnly) { if (cbox) [].forEach.call(cbox.querySelectorAll('.mx-qa__k'), function (k) { var v = d.v.find(function (x) { return x[1] === k.dataset.col; }); if (!v || !v[3]) { k.disabled = true; k.setAttribute('aria-label', k.dataset.col + ', sold out'); k.style.opacity = '.4'; } }); return; }
    d.s.forEach(function (s) {
      var v = col == null ? null : d.v.find(function (x) { return x[1] === col && x[2] === s; });
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mx-qa__z'; b.textContent = s;
      if (col == null) { b.disabled = true; b.setAttribute('aria-label', s + ', choose a colour first'); }
      else if (!v || !v[3]) { b.disabled = true; b.setAttribute('aria-label', s + ', sold out'); }
      else b.dataset.id = v[0];
      box.appendChild(b);
    });
    q.querySelector('[data-mx-qa-msg]').textContent = '';
  }
  function pickColour(q, name) {
    var d = data(q), c = card(q), i = d.c.indexOf(name); q.__col = name;
    if (d.s.length === 1 && d.s[0] === '') {   /* colour-only product: one tap, straight into the bag */
      var v = d.v.find(function (x) { return x[1] === name && x[3]; });
      if (v) { add(q, v[0], null); return; }
    }
    [].forEach.call(c.querySelectorAll('.mx-sw__d'), function (x) { x.setAttribute('aria-pressed', (+x.dataset.ci === i) ? 'true' : 'false'); });
    var dot = c.querySelector('.mx-sw__d[aria-pressed="true"]');
    if (dot) { link(c, dot.dataset.variant); show(dot); } else { link(c, null); restore(c); }
    paint(q);
    var f = q.querySelector('.mx-qa__z:not([disabled])'); if (f) f.focus({ preventScroll: true });
  }
  function closeAll(except) {
    [].forEach.call(document.querySelectorAll('[data-mx-qa].is-open'), function (q) { if (q !== except) close(q, false); });
  }
  /* STORE TEAM (12 Oct 2026): on a phone the picker is a bottom sheet in the top layer (popover API), so it escapes the
     card's containment, gets a scrim and slides up (@starting-style in ma-qa.css). Desktop keeps the in-card panel. */
  var SHEET = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false };
  function asSheet(p) { return SHEET.matches && typeof p.showPopover === 'function'; }
  function title(q, p) {
    if (p.querySelector('.mx-qa__t')) return;
    var t = document.createElement('p'); t.className = 'mx-qa__t'; t.textContent = q.getAttribute('data-title') || '';
    p.insertBefore(t, p.firstChild);
  }
  function open(q) {
    closeAll(q);
    var p = q.querySelector('[data-mx-qa-panel]'); if (!p) return;
    paint(q);
    if (asSheet(p)) { title(q, p); p.setAttribute('popover', 'manual'); p.hidden = false; try { p.showPopover(); } catch (e) {} p.classList.add('is-sheet'); }
    else p.hidden = false;
    q.classList.add('is-open');
    q.querySelector('[data-mx-qa-open]').setAttribute('aria-expanded', 'true');
    var f = p.querySelector('.mx-qa__z:not([disabled])') || p.querySelector('.mx-qa__k'); if (f) f.focus({ preventScroll: true });
  }
  function close(q, refocus) {
    var p = q.querySelector('[data-mx-qa-panel]');
    if (p) {
      if (p.classList.contains('is-sheet')) { try { p.hidePopover(); } catch (e) {} p.removeAttribute('popover'); p.classList.remove('is-sheet'); }
      p.hidden = true;
    }
    q.classList.remove('is-open');
    var b = q.querySelector('[data-mx-qa-open]'); b.setAttribute('aria-expanded', 'false'); if (refocus) b.focus({ preventScroll: true });
  }
  async function addLine(source, id) {
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: def.promise }));
      } catch (e) { def = null; }
    }
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var secs = [].map.call(document.querySelectorAll('cart-items-component'), function (n) { return n.dataset && n.dataset.sectionId; }).filter(Boolean);
    if (secs.length) body.sections = secs.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { cart = await (await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mx-qa', sourceId: 'mx-qa', itemCount: 1, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    }
    return { ok: ok, json: json, events: !!def };
  }
  async function add(q, id, btn) {
    var msg = q.querySelector('[data-mx-qa-msg]'), ob = q.querySelector('[data-mx-qa-open]');
    ob.setAttribute('aria-busy', 'true'); if (btn) btn.disabled = true;
    var r = await addLine(q, id);
    ob.removeAttribute('aria-busy'); if (btn) btn.disabled = false;
    if (r.ok) {
      dl({ event: 'add_to_cart', source: 'card_quick_add', items: [{ item_id: String(id), quantity: 1 }] });
      if (msg) msg.textContent = '';
      close(q, false);
      ob.classList.add('is-added'); setTimeout(function () { ob.classList.remove('is-added'); }, 1800);
      if (!r.events) location.href = routes.cart_url || (ROOT + 'cart');
    } else if (msg) {
      msg.textContent = (r.json && (r.json.description || r.json.message)) || 'Could not add that size. Try again.';
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var dot = t.closest('.mx-sw__d'); if (dot) { e.preventDefault(); if (dot.dataset.href) { location.href = dot.dataset.href; return; } chooseDot(dot); return; }
    var ob = t.closest('[data-mx-qa-open]');
    if (ob) {
      e.preventDefault(); var q = ob.closest('[data-mx-qa]');
      if (q.dataset.single) { add(q, q.dataset.single, null); return; }
      if (q.classList.contains('is-open')) close(q, true); else open(q);
      return;
    }
    var x = t.closest('[data-mx-qa-close]'); if (x) { close(x.closest('[data-mx-qa]'), true); return; }
    var k = t.closest('.mx-qa__k'); if (k) { pickColour(k.closest('[data-mx-qa]'), k.dataset.col); return; }
    var z = t.closest('.mx-qa__z'); if (z && z.dataset.id) { add(z.closest('[data-mx-qa]'), z.dataset.id, z); return; }
    if (!t.closest('[data-mx-qa]')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var q = document.querySelector('[data-mx-qa].is-open'); if (q) close(q, true);
  });

  /* Touch devices swipe the card photos: make that scroller a labelled, keyboard-focusable region (axe: scrollable-region-focusable). */
  function arm() {
    if (!window.matchMedia('(hover: none)').matches) return;
    [].forEach.call(document.querySelectorAll('[data-mx-track2]:not([tabindex])'), function (t) {
      var c = card(t), n = c && c.querySelector('[data-mx-qa]');
      t.setAttribute('tabindex', '0'); t.setAttribute('role', 'group');
      t.setAttribute('aria-label', ((n && n.dataset.title) || 'Product') + ' photos');
    });
  }
  arm();
  if (window.MutationObserver) new MutationObserver(function () { arm(); }).observe(document.body, { childList: true, subtree: true });
})();
